export class BancoConvenio {
  ConvenioNumero = null;
  ConvenioDescricao = null;
  ConvenioCarteira = null;
  carteira_codigo = null;
  ConvenioEspecie = null;
  ConvenioPadraoCNAB = null;
  ConvenioNumeroRemessa = null;
  ConvenioReiniciarDiariamente = null;
  ConvenioNumeroContrato = null;
  Conta = null;

  constructor(convenio, contaId) {
    this.ConvenioNumero = convenio.numero;
    this.ConvenioDescricao = convenio.descricao;
    this.ConvenioCarteira = convenio.carteira;
    this.carteira_codigo = convenio.codigoCarteira;
    this.ConvenioEspecie = "R$";
    this.ConvenioPadraoCNAB = convenio.padraoCnab;
    this.ConvenioNumeroRemessa = convenio.numeroRemessaInicial;
    this.ConvenioReiniciarDiariamente = convenio.numeroRemessaDinamico ?? false;
    this.ConvenioNumeroContrato = convenio.numeroContrato;
    this.Conta = contaId;
  }
}
